import { DOMAIN_API_URL } from '@/services/constants';
import { BACKEND_BASE_URL } from '@/config'

import axiosClient from '../axiosClient';

const DomainServices = {
  fetchDomains: async (params: any) => {
    const response = await axiosClient.get(`${DOMAIN_API_URL}`, {
      params,
    });
    return response.data;
  },
  createDomain: async (body: any, inputDomain: string) => {
    try {
      const response: any = await fetch(`${BACKEND_BASE_URL}${DOMAIN_API_URL}/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'XSM-Domain': inputDomain as string,
          Authorization: `Bearer ${localStorage.getItem('xsm_access_token')}`,
        },
        body: JSON.stringify(body),
      });
      const result = await response.json();

      return result;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  deleteDomain: async (domainId: string) => {
    try {
      const response = await axiosClient.delete(`${DOMAIN_API_URL}`, {
        params: {
          domainId,
        },
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  updateDomain: async (body: any, domainId: any) => {
    try {
      const response = await axiosClient.put(`${DOMAIN_API_URL}/${domainId}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  downloadDomain: async () => {
    try {
      const response = await axiosClient.get(`${DOMAIN_API_URL}/download`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
};

export default DomainServices;
